module.exports = __webpack_public_path__ + "1c017eeb7e8df68d7f7e52db75cb7190.svg";